/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
export var webHookRequest = function (title, description, color) {
    return {
        embeds: [
            {
                title: title,
                description: description,
                color: color,
            },
        ],
    };
};
